import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faChartLine,
  faLayerGroup,
  faWallet,
} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'finance-pwa-bottom-nav',
  standalone: true,
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
})
export class BottomNavComponent {
  iconDashboard = faChartLine;
  iconAssets = faLayerGroup;
  iconPayments = faWallet;
}
